import { Component, Input, OnInit } from '@angular/core';
import Debug from 'debug';

const debug = Debug('aumico:aumico-layout:TabsNavigationComponent');

interface NavigationItem {
    text: string;
    routerLink: string;
}
@Component({
    selector: 'aumico-tabs-navigation',
    template: `
        <ng-container>
            <div class="tabs-area">
                <ng-container>
                    <div routerLinkActive="active" *ngFor="let item of navigationItems">
                        <a [routerLink]="item.routerLink" class="nav-link">{{ item.text }}</a>
                    </div>
                </ng-container>
                <ng-content></ng-content>
            </div>
            <div class="tab-content-area">
                <ng-content select="[content]"></ng-content>
            </div>
        </ng-container>
    `,
    styleUrls: ['./tabs-navigation.component.scss'],
})
export class TabsNavigationComponent implements OnInit {
    @Input() navigationItems: NavigationItem[];

    constructor() {}

    ngOnInit() {}
}
